/* eslint-disable */

import { defineStore } from 'pinia';
import merge from 'sugar/object/merge'
const ANSWER_UNIQ_KEYS = ['field_id', 'option_id', 'likert_id',]
const answerKey = function(answer){
  const data = ANSWER_UNIQ_KEYS.map(k=> `${answer[k] === null || answer[k] === undefined ? '' : answer[k]}`)
  data.push( (answer.data || {}).contact_uid )
  return data.join('__')
}

export {answerKey}

export const useFormResultStore = (formResult)=>{
  const storeKey = `formResult__${formResult.subtypeId||formResult.form_id}__${formResult.id}`
  // console.log("Creating store with key", storeKey )
  const storeCreation =  defineStore(storeKey, {
    state: () => ({
      formResult: null,
      answersDict: {},
    }),
    getters: {
      asJson(){
        return {
          ...this.formResult,
          form_result_answers: Object.values(this.answersDict)
        }
      },
      answers(){ return Object.values(this.answersDict) },
    },
    actions: {
      addAnswer(answer){
        const key = answerKey(answer)
        this.answersDict[key] ||= {}
        const oldAnswer = this.answersDict[key] || {}
        this.answersDict[key] = merge(oldAnswer, answer, {deep: true})
        if (oldAnswer.id && !this.answersDict[key].id) this.answersDict[key].id = oldAnswer.id
        if (this.answersDict[key]._destroy) delete this.answersDict[key]._destroy

        return this.answersDict[key]
      },
      getAnswer(answer){
        const key = answerKey(answer)
        return this.answersDict[key] ||= {}
      },
      findAnswer(answer){
        const key = answerKey(answer)
        return this.answersDict[key]
      },
      delAnswer(answer){
        if (answer.id){
          const localAnswer = this.getAnswer(answer)
          localAnswer._destroy  = '1'
          localAnswer.checked   = false
          localAnswer.likert_id = null
        }else {
          const key = answerKey(answer)
          delete this.answersDict[key]
        }
      },
      answerUnchecked(answer, field, allFields){
        if (answer.checked || !field.datahash.branching_enabled) return
        for (const value of field.datahash?.options?.values || []){
          if (value.option_id !== answer.option_id || !value.conditional_field_group_js_ids?.length) continue

          const fieldGroup = allFields.find(f=>value.conditional_field_group_js_ids?.includes(f.datahash._js_id))
          if (fieldGroup && !this.fieldGroupIsVisible(fieldGroup, allFields)) this.deleteAnswersByFieldGroup(fieldGroup, allFields)
        }
      },
      deleteAnswersByFieldGroup(fieldGroup, allFields){
        for (const field of fieldGroup.fields){
          this.answersByField(field.id).filter(a=> a._destroy !== '1').forEach(a=>{
            this.delAnswer(a)
            if (['CheckboxAnswer','RadioAnswer'].includes(a.type)) this.answerUnchecked(a,field, allFields)
          })
        }
      },
      fieldGroupIsVisible(fieldGroup, allFields) {
        const condition_fields = fieldGroup.datahash.condition_fields || []
        if (condition_fields.length === 0) {
          return true;
        }
        return allFields.some(otherField => {
          if (otherField.type === "FieldGroup"){
            return this.fieldGroupIsVisible(fieldGroup, otherField.fields)
          } else {
            const otherFieldOptions = (otherField.datahash.options?.values || [])
            return otherFieldOptions.some(option => {
              const isOptionMatched = option.conditional_field_group_js_ids?.includes(fieldGroup.datahash['_js_id'])
              if (isOptionMatched) {
                return this.answersByFieldAndOption(otherField.id, option.option_id)[0]?.checked
              } else {
                return false
              }
            })
          }

        })
      },
      answersByField(fieldId){
        // const arr = []
        // for (const key in this.answersDict){
        //   const e = this.answersDict[key]
        //   if (e.field_id === fieldId) arr.push(e)
        // }
        // return arr
        return this.answers.filter(e=>e.field_id === fieldId)
      },
      answersByFieldAndOption(fieldId, optionId){
        return this.answers.filter(e=>e.field_id === fieldId && e.option_id === optionId)
      },

      setNewFormResult(formResult, reset=false){
        this.formResult = formResult
        if (reset) this.answersDict = {}
        for (const fra of this.formResult.form_result_answers||[]){
          this.addAnswer(fra)
        }
      },
    }
  })
  const store = storeCreation()
  if (!store.formResult){
    store.setNewFormResult(formResult)
  }
  store.storeCreation=storeCreation
  return store
}